import { lazy, Suspense } from "react";

import { Stack } from "@seneca/senekit";

const FeedbackSuccessAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: "feedback-success-animation" */ "./FeedbackSuccessAnimation"
    )
);

export default function FeedbackSuccess(props: {
  speed?: number;
  width?: string;
  height?: string;
}) {
  return (
    <Stack align="center" space="xlarge">
      <Suspense fallback={null}>
        <FeedbackSuccessAnimation {...props} />
      </Suspense>
    </Stack>
  );
}
